document.addEventListener('DOMContentLoaded', function () {

  document
    .querySelectorAll('.image-text-slider-swiper')
    .forEach(function(slider){

      new Swiper(slider, {
        loop: true,

        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },

        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true
        },


      });

    });

});